'use strict';

import angular from  "angular";

export default angular.module('PrivKey',[])
.factory('PrivKey',['$window',function($window){
	function _arrayBufferToBase64( buffer ) {
		var binary = '';
		var bytes = new Uint8Array( buffer );
		var len = bytes.byteLength;
		for (var i = 0; i < len; i++) {
			binary += String.fromCharCode( bytes[ i ] );
		}
		return window.btoa( binary );
	}
	function _base64ToArrayBuffer(base64) {
		var binary_string =  window.atob(base64);
		var len = binary_string.length;
		var bytes = new Uint8Array( len );
		for (var i = 0; i < len; i++)        {
			bytes[i] = binary_string.charCodeAt(i);
		}
		return bytes.buffer;
	}
	function ab2str(buf) {
		return String.fromCharCode.apply(null, new Uint16Array(buf));
	}
	function str2ab(str) {
		var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
		var bufView = new Uint16Array(buf);
		for (var i=0, strLen=str.length; i < strLen; i++) {
			bufView[i] = str.charCodeAt(i);
		}
		return buf;
	}
	function hexString2ByteArray(hexString) {
		var result = [];
		while (hexString.length >= 2) {
			result.push(parseInt(hexString.substring(0, 2), 16));
			hexString = hexString.substring(2, hexString.length);
		}
		return result;
	}

	var privKey = {};
	var keys = [];

	function localKeys(){
		try{
			var k = JSON.parse($window.localStorage['privateKeys']);
			if(!Array.isArray(k)){
				throw new Error('Invalid private key store');
			}
			return k;
		}catch(e){
			return [];
		}
	}


	privKey.getPublicKeyBlob = function(key,passphrase){
		var keyObj;
		try{
			keyObj = KEYUTIL.getKey(key.key,passphrase);
		}catch(e){
			console.log(e);
			return;
		}

		switch(keyObj.type){
			case 'RSA':
				var ba = keyObj.n.toByteArray();
				if(ba[0] === 0){
				//	ba.splice(0,1);
				}
				var str = 'ssh-rsa';
				var ab = new ArrayBuffer(
					4 //4 bytes - unsigned int: length X of string to come
					+ str.length //X bytes - string: this will be 'ssh-rsa' (7 chars)
					+ 4 //4 bytes - unsigned int: length Y of byte array
					+ 4 //Y bytes - bigint of 'e'
					+ 4 //4 bytes - unsigned int: length Z of byte array
					+ ba.length  //Z bytes - bigint of 'n'
				);
				var dv = new DataView(ab);
				dv.setUint32(0,str.length);
				for(var i = 0; i< str.length; i++){
					dv.setUint8(4+i,str.charCodeAt(i));
				}
				dv.setUint32(4+str.length,4);
				dv.setUint32(8+str.length,keyObj.e);
				dv.setUint32(12+str.length,ba.length);
				var n = new Uint8Array(ab,16 +str.length);
				n.set(new Uint8Array(ba,0,ba.length -1));
				return _arrayBufferToBase64(ab);
		}
	}
	privKey.sign = function(key,base64,passphrase){
		var keyObj = KEYUTIL.getKey(key.key,passphrase);
		switch(keyObj.type){
			case 'RSA':
				var hex = b64utohex(b64tob64u(base64));
				var sig = new KJUR.crypto.Signature({"alg": "SHA1withRSA"});
				sig.initSign(keyObj);
				sig.updateHex(hex);
				var hSigVal = sig.sign();
				return b64utob64(hextob64u(hSigVal));
		}
	}

	privKey.loadKeys = function(){
		keys = localKeys();
		return keys;
	}
	privKey.loadNextKey = function(cycle){
		var k;
		if(cycle){
			if(!keys.length){
				privKey.loadKeys();
			}
		}
		while( k= keys.shift()){
			return k;
		}
	}

	function createKeyFormat(pk){
		var key = {};
		var lines = pk.split('\n');
		if(lines[0].search(/-----BEGIN RSA PRIVATE KEY-----/) >=0){
			key.format = 'pkcs1';
			if(lines[1].search(/ENCRYPTED/) >=0){
				key.encrypted = true;
			}
		}else if(lines[0].search(/-----BEGIN PRIVATE KEY-----/) >= 0){
			key.format = 'pkcs8';
		}else if(lines[0].search(/-----BEGIN ENCRYPTED PRIVATE KEY-----/) >= 0){
			key.format = 'pkcs8';
			key.encrypted = true;
		}else{
			return null;
		}
		key.key = pk;
		return key;
	}
	privKey.deleteKey = function(pk){
		var k = localKeys();
		for(var i =0; i<k.length;i++){
			if(k[i].key === pk){
				k.splice(i,1);
				$window.localStorage['privateKeys'] = JSON.stringify(k);
				return true;
			}
		}
	}
	privKey.storeKey = function(pk,filename){
		var key = createKeyFormat(pk);
		if(key){
			key.filename = filename;
			var k = localKeys();
			k.push(key);
			$window.localStorage['privateKeys'] = JSON.stringify(k);
			return true;
		}
	}
	return privKey;
}]);



//////////////////
// WEBPACK FOOTER
// ./auth/priv-key.js
// module id = 14
// module chunks = 0